module.exports = "/7/1-thiet-ke-chuong-trinh-dua-tren-khai-niem-function/index.html.0dd052d16304cb05be843573b6ec0e45.json"


/*****************
 ** WEBPACK FOOTER
 ** ./content/generated/30133.md
 ** module id = 561
 ** module chunks = 0
 **/